const competitionEvent = {
  //  赛事推荐banner列表 -- 刘琪
  recommandBanner: `/pcApi/v1/homeapi/Match/recommandBanner`,
  // 专区banner列表 -- 刘琪
  areaBanner: `/pcApi/v1/homeapi/Match/areaBanner`,
  // 专区列表 -- 刘琪
  areaList: `/pcApi/v1/homeapi/Match/areaList`,
  // 资讯分类列表 -- 刘琪
  infoAssortList: `/pcApi/v1/homeapi/Match/infoAssortList`,
  // 获取资讯 -- 刘琪
  getInfo: `/pcApi/v1/homeapi/Match/getInfo`,
  // 赛事日历接口 -- 贾琳
  matchCalendar: `/pcApi/v1/homeapi/Match/matchCalendar`,
  // 赛事日历列表接口 -- 贾琳
  matchCalendarList: `/pcApi/v1/homeapi/Match/matchCalendarList`,
  // 推荐日历赛事接口 -- 贾琳
  MatchArea: `/pcApi/v1/homeapi/Match/MatchArea`,
  // 专区概述接口 -- 贾琳
  matchAreaSummary: `/pcApi/v1/homeapi/Match/matchAreaSummary`,
  // 推荐日历赛事接口 -- 贾琳
  matchArea: `/pcApi/v1/homeapi/Match/MatchArea`,
  // 增加观看次数 -- 贾琳
  playTimes: `/pcApi/v1/homeapi/Match/playTimes`,
  // 赛事资讯 -- 刘琪
  matchInfo: `/pcApi/v1/homeapi/Match/matchInfo`,
  // 登录游戏接口 -- 贾琳
  matchAreaGame: `/pcApi/v1/homeapi/Match/matchAreaGame`,
  // 专区赛事概述标题 -- 贾琳
  matchOutsTitle: `/pcApi/v1/homeapi/Match/matchOutsTitle`,
  // 赛况概述接口 -- 贾琳
  matchOuts: `/pcApi/v1/homeapi/Match/matchOuts`,
  // 专区背景图 -- 贾琳
  matchAreaBackground: `/pcApi/v1/homeapi/Match/matchAreaBackground`,
  // 赛事入口配置 -- 刘琪
  matchEntry: `/pcApi/v1/homeapi/Match/matchEntry`
};

export default competitionEvent;
